import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuthenticated, localStorageMethod } from 'src/common/config/FunctionHelper';
import { paths } from 'src/common/config/TextMessage';
import { Box, CircularProgress } from '@mui/material';

const OrbitAIPublicLinkHandler = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Set flag in localStorage so modal opens on dashboard after login/redirection
    localStorageMethod('set', 'open_orbit_ai_modal', 'true');

    const isAuthenticated = getAuthenticated();
    if (isAuthenticated === 'true') {
      navigate(paths?.dashboard, { replace: true });
    } else {
      navigate(paths?.signin, { replace: true });
    }
  }, [navigate]);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh'
      }}
    >
      <CircularProgress disableShrink />
    </Box>
  );
};

export default OrbitAIPublicLinkHandler;
